import React from 'react';
import "./Timeline.css";

const Timeline = (props) => {
  const {children} = props;
  return (
      <ul className="asset-timeline timeline timeline-inverse">
        {children}
      </ul>
  );
};

Timeline.propTypes = {};

export default Timeline;




// WEBPACK FOOTER //
// ./src/component/Timeline/Timeline.js